import { get } from "./base";

export async function getOrderList(params) {
    let respObj = await get("/bus/order/my-order", params);
    return respObj.list;
}